import { combineReducers } from 'redux';

import userReducer from './User/reducer';
import opportunityReducer from './Opportunity/reducer';
import heatmapReducer from './Heatmap/reducer';
import campaignReducer from './Campaign/reducer';
import ContactReducer from './Contact/reducer';
import fundsReducer from './Funds/reducer';
import marketingReducer from './Marketing/reducer';
import programReducer from './Program/reducer';
import widgetsReducer from './Widgets/reducer';
import databaseBackupsReducer from './DatabaseBackups/reducer';
import staticDataReducer from './staticData/reducer';
import listsReducer from './Lists/reducer';
import licenseReducer from './License/reducer';
import coSellOpportunityReducer from './CoSellOpportunity/reducer';
import mappingReducer from './Mapping/reducer';

// Combine all the reducers
export default combineReducers({
	user: userReducer,
	opportunity: opportunityReducer,
	heatmap: heatmapReducer,
	campaign: campaignReducer,
	contact: ContactReducer,
	fund: fundsReducer,
	marketing: marketingReducer,
	program: programReducer,
	widget: widgetsReducer,
	databaseBackups: databaseBackupsReducer,
	staticData: staticDataReducer,
	lists: listsReducer,
	license: licenseReducer,
	coSellOpportunity: coSellOpportunityReducer,
	mapping: mappingReducer
});
